export default __webpack_public_path__ + "static/media/487.9e8fad2f.png";